import {config as baseConfig} from './config.base';
import {config as devConfig} from './config.dev';
import {config as localConfig} from './config.local';
import {config as previewConfig} from './config.preview';
import {config as prodConfig} from './config.prod';
import {config as stgConfig} from './config.stg';
import type {Config} from './extend-config';
import {extendConfig} from './extend-config';

const envs = [`prod`, `stg`, `preview`, `dev`, `local`] as const;
type Env = (typeof envs)[number];
const isValidEnv = (env?: string): env is Env => !!env && envs.includes(env as Env);

const providedEnv = process.env.NEXT_PUBLIC_ENVIRONMENT;
const isCI = process.env.CI === `true`;

if (isCI) {
  if (!isValidEnv(providedEnv)) {
    throw new Error(`NEXT_PUBLIC_ENVIRONMENT must be set to one of ${envs.join(`, `)} when CI=true.`);
  }
} else if (!isValidEnv(providedEnv)) {
  console.warn(`NEXT_PUBLIC_ENVIRONMENT is not set or invalid. Falling back to "local" configuration.`);
}

const DEPLOY_ENV = isValidEnv(providedEnv) ? providedEnv : `local`;

const getConfig = (env?: string): Config => {
  if (!isValidEnv(env)) {
    throw new Error(`Invalid environment: ${env}`);
  }
  let conf;
  switch (env) {
    case `prod`:
      conf = prodConfig;
      break;
    case `stg`:
      conf = stgConfig;
      break;
    case `preview`:
      conf = previewConfig;
      break;
    case `dev`:
      conf = devConfig;
      break;
    case `local`:
      conf = localConfig;
      break;
    default:
      conf = baseConfig;
      break;
  }

  return conf;
};

export const config = extendConfig(getConfig(DEPLOY_ENV)) as typeof baseConfig & Config;
export type {Config};
